var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5V31.231H23V33.5H0ZM24.9965 19.1345C22.4682 19.1345 20.3142 18.2435 18.5345 16.4615C16.7552 14.6795 15.8655 12.5245 15.8655 9.99648C15.8655 7.46815 16.7565 5.31415 18.5385 3.53448C20.3205 1.75515 22.4755 0.865479 25.0035 0.865479C27.5318 0.865479 29.6858 1.75648 31.4655 3.53848C33.2448 5.32048 34.1345 7.47548 34.1345 10.0035C34.1345 12.5318 33.2435 14.6858 31.4615 16.4655C29.6795 18.2448 27.5245 19.1345 24.9965 19.1345ZM0 16.769V14.5H12.0425C12.1942 14.916 12.3552 15.3071 12.5255 15.6735C12.6955 16.0398 12.8818 16.405 13.0845 16.769H0ZM0 25.1345V22.8655H20.2385C20.6728 23.0391 21.1243 23.1818 21.593 23.2935C22.0617 23.4055 22.5307 23.4948 23 23.5615V25.1345H0ZM24.1155 15.8845H25.8845V8.30748H24.1155V15.8845ZM25 6.19248C25.2667 6.19248 25.5 6.09248 25.7 5.89248C25.9 5.69248 26 5.45914 26 5.19248C26 4.92581 25.9 4.69248 25.7 4.49248C25.5 4.29248 25.2667 4.19248 25 4.19248C24.7333 4.19248 24.5 4.29248 24.3 4.49248C24.1 4.69248 24 4.92581 24 5.19248C24 5.45914 24.1 5.69248 24.3 5.89248C24.5 6.09248 24.7333 6.19248 25 6.19248Z",
    fill: "#F88D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDetail);
export default __webpack_public_path__ + "static/media/productDetail.2c9cda97172f8646d0b5d7d583dd235a.svg";
export { ForwardRef as ReactComponent };